function a(e, t, n) {
  function o(c, u) {
    if (c._zod || Object.defineProperty(c, "_zod", {
      value: {
        def: u,
        constr: s,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), c._zod.traits.has(e))
      return;
    c._zod.traits.add(e), t(c, u);
    const l = s.prototype, f = Object.keys(l);
    for (let d = 0; d < f.length; d++) {
      const g = f[d];
      g in c || (c[g] = l[g].bind(c));
    }
  }
  const r = (n == null ? void 0 : n.Parent) ?? Object;
  class i extends r {
  }
  Object.defineProperty(i, "name", { value: e });
  function s(c) {
    var u;
    const l = n != null && n.Parent ? new i() : this;
    o(l, c), (u = l._zod).deferred ?? (u.deferred = []);
    for (const f of l._zod.deferred)
      f();
    return l;
  }
  return Object.defineProperty(s, "init", { value: o }), Object.defineProperty(s, Symbol.hasInstance, {
    value: (c) => {
      var u, l;
      return n != null && n.Parent && c instanceof n.Parent ? !0 : (l = (u = c == null ? void 0 : c._zod) == null ? void 0 : u.traits) == null ? void 0 : l.has(e);
    }
  }), Object.defineProperty(s, "name", { value: e }), s;
}
class W extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class qe extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Ye = {};
function U(e) {
  return Ye;
}
function Xe(e) {
  const t = Object.values(e).filter((o) => typeof o == "number");
  return Object.entries(e).filter(([o, r]) => t.indexOf(+o) === -1).map(([o, r]) => r);
}
function _e(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function ve(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function ye(e) {
  return e == null;
}
function ze(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function Et(e, t) {
  const n = (e.toString().split(".")[1] || "").length, o = t.toString();
  let r = (o.split(".")[1] || "").length;
  if (r === 0 && /\d?e-\d?/.test(o)) {
    const u = o.match(/\d?e-(\d?)/);
    u != null && u[1] && (r = Number.parseInt(u[1]));
  }
  const i = n > r ? n : r, s = Number.parseInt(e.toFixed(i).replace(".", "")), c = Number.parseInt(t.toFixed(i).replace(".", ""));
  return s % c / 10 ** i;
}
const Oe = Symbol("evaluating");
function v(e, t, n) {
  let o;
  Object.defineProperty(e, t, {
    get() {
      if (o !== Oe)
        return o === void 0 && (o = Oe, o = n()), o;
    },
    set(r) {
      Object.defineProperty(e, t, {
        value: r
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function V(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function L(...e) {
  const t = {};
  for (const n of e) {
    const o = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, o);
  }
  return Object.defineProperties({}, t);
}
function Ee(e) {
  return JSON.stringify(e);
}
function Tt(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const He = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function se(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const It = ve(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function G(e) {
  if (se(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(se(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function Qe(e) {
  return G(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Pt = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function q(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function M(e, t, n) {
  const o = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (o._zod.parent = e), o;
}
function h(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Nt(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const Dt = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function At(e, t) {
  const n = e._zod.def, o = n.checks;
  if (o && o.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = L(e._zod.def, {
    get shape() {
      const s = {};
      for (const c in t) {
        if (!(c in n.shape))
          throw new Error(`Unrecognized key: "${c}"`);
        t[c] && (s[c] = n.shape[c]);
      }
      return V(this, "shape", s), s;
    },
    checks: []
  });
  return M(e, i);
}
function jt(e, t) {
  const n = e._zod.def, o = n.checks;
  if (o && o.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = L(e._zod.def, {
    get shape() {
      const s = { ...e._zod.def.shape };
      for (const c in t) {
        if (!(c in n.shape))
          throw new Error(`Unrecognized key: "${c}"`);
        t[c] && delete s[c];
      }
      return V(this, "shape", s), s;
    },
    checks: []
  });
  return M(e, i);
}
function Ct(e, t) {
  if (!G(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const i = e._zod.def.shape;
    for (const s in t)
      if (Object.getOwnPropertyDescriptor(i, s) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const r = L(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return V(this, "shape", i), i;
    }
  });
  return M(e, r);
}
function Rt(e, t) {
  if (!G(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = L(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return V(this, "shape", o), o;
    }
  });
  return M(e, n);
}
function Ft(e, t) {
  const n = L(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t._zod.def.shape };
      return V(this, "shape", o), o;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return M(e, n);
}
function Ut(e, t, n) {
  const r = t._zod.def.checks;
  if (r && r.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const s = L(t._zod.def, {
    get shape() {
      const c = t._zod.def.shape, u = { ...c };
      if (n)
        for (const l in n) {
          if (!(l in c))
            throw new Error(`Unrecognized key: "${l}"`);
          n[l] && (u[l] = e ? new e({
            type: "optional",
            innerType: c[l]
          }) : c[l]);
        }
      else
        for (const l in c)
          u[l] = e ? new e({
            type: "optional",
            innerType: c[l]
          }) : c[l];
      return V(this, "shape", u), u;
    },
    checks: []
  });
  return M(t, s);
}
function xt(e, t, n) {
  const o = L(t._zod.def, {
    get shape() {
      const r = t._zod.def.shape, i = { ...r };
      if (n)
        for (const s in n) {
          if (!(s in i))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (i[s] = new e({
            type: "nonoptional",
            innerType: r[s]
          }));
        }
      else
        for (const s in r)
          i[s] = new e({
            type: "nonoptional",
            innerType: r[s]
          });
      return V(this, "shape", i), i;
    }
  });
  return M(t, o);
}
function B(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let o = t; o < e.issues.length; o++)
    if (((n = e.issues[o]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function K(e, t) {
  return t.map((n) => {
    var o;
    return (o = n).path ?? (o.path = []), n.path.unshift(e), n;
  });
}
function te(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function x(e, t, n) {
  var r, i, s, c, u, l;
  const o = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const f = te((s = (i = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : i.error) == null ? void 0 : s.call(i, e)) ?? te((c = t == null ? void 0 : t.error) == null ? void 0 : c.call(t, e)) ?? te((u = n.customError) == null ? void 0 : u.call(n, e)) ?? te((l = n.localeError) == null ? void 0 : l.call(n, e)) ?? "Invalid input";
    o.message = f;
  }
  return delete o.inst, delete o.continue, t != null && t.reportInput || delete o.input, o;
}
function be(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Q(...e) {
  const [t, n, o] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: o
  } : { ...t };
}
const et = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, _e, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, tt = a("$ZodError", et), nt = a("$ZodError", et, { Parent: Error });
function Lt(e, t = (n) => n.message) {
  const n = {}, o = [];
  for (const r of e.issues)
    r.path.length > 0 ? (n[r.path[0]] = n[r.path[0]] || [], n[r.path[0]].push(t(r))) : o.push(t(r));
  return { formErrors: o, fieldErrors: n };
}
function Mt(e, t = (n) => n.message) {
  const n = { _errors: [] }, o = (r) => {
    for (const i of r.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((s) => o({ issues: s }));
      else if (i.code === "invalid_key")
        o({ issues: i.issues });
      else if (i.code === "invalid_element")
        o({ issues: i.issues });
      else if (i.path.length === 0)
        n._errors.push(t(i));
      else {
        let s = n, c = 0;
        for (; c < i.path.length; ) {
          const u = i.path[c];
          c === i.path.length - 1 ? (s[u] = s[u] || { _errors: [] }, s[u]._errors.push(t(i))) : s[u] = s[u] || { _errors: [] }, s = s[u], c++;
        }
      }
  };
  return o(e), n;
}
const we = (e) => (t, n, o, r) => {
  const i = o ? Object.assign(o, { async: !1 }) : { async: !1 }, s = t._zod.run({ value: n, issues: [] }, i);
  if (s instanceof Promise)
    throw new W();
  if (s.issues.length) {
    const c = new ((r == null ? void 0 : r.Err) ?? e)(s.issues.map((u) => x(u, i, U())));
    throw He(c, r == null ? void 0 : r.callee), c;
  }
  return s.value;
}, ke = (e) => async (t, n, o, r) => {
  const i = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let s = t._zod.run({ value: n, issues: [] }, i);
  if (s instanceof Promise && (s = await s), s.issues.length) {
    const c = new ((r == null ? void 0 : r.Err) ?? e)(s.issues.map((u) => x(u, i, U())));
    throw He(c, r == null ? void 0 : r.callee), c;
  }
  return s.value;
}, de = (e) => (t, n, o) => {
  const r = o ? { ...o, async: !1 } : { async: !1 }, i = t._zod.run({ value: n, issues: [] }, r);
  if (i instanceof Promise)
    throw new W();
  return i.issues.length ? {
    success: !1,
    error: new (e ?? tt)(i.issues.map((s) => x(s, r, U())))
  } : { success: !0, data: i.value };
}, Jt = /* @__PURE__ */ de(nt), pe = (e) => async (t, n, o) => {
  const r = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: n, issues: [] }, r);
  return i instanceof Promise && (i = await i), i.issues.length ? {
    success: !1,
    error: new e(i.issues.map((s) => x(s, r, U())))
  } : { success: !0, data: i.value };
}, Vt = /* @__PURE__ */ pe(nt), Bt = (e) => (t, n, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return we(e)(t, n, r);
}, Kt = (e) => (t, n, o) => we(e)(t, n, o), Wt = (e) => async (t, n, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return ke(e)(t, n, r);
}, Gt = (e) => async (t, n, o) => ke(e)(t, n, o), qt = (e) => (t, n, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return de(e)(t, n, r);
}, Yt = (e) => (t, n, o) => de(e)(t, n, o), Xt = (e) => async (t, n, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return pe(e)(t, n, r);
}, Ht = (e) => async (t, n, o) => pe(e)(t, n, o), Qt = /^[cC][^\s-]{8,}$/, en = /^[0-9a-z]+$/, tn = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, nn = /^[0-9a-vA-V]{20}$/, on = /^[A-Za-z0-9]{27}$/, rn = /^[a-zA-Z0-9_-]{21}$/, sn = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, cn = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Te = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, un = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, an = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function ln() {
  return new RegExp(an, "u");
}
const fn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, dn = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, pn = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, hn = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, mn = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, ot = /^[A-Za-z0-9_-]*$/, _n = /^\+[1-9]\d{6,14}$/, rt = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", gn = /* @__PURE__ */ new RegExp(`^${rt}$`);
function it(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function vn(e) {
  return new RegExp(`^${it(e)}$`);
}
function yn(e) {
  const t = it({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const o = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${rt}T(?:${o})$`);
}
const zn = (e) => {
  const t = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, bn = /^-?\d+$/, st = /^-?\d+(?:\.\d+)?$/, wn = /^(?:true|false)$/i, kn = /^[^A-Z]*$/, $n = /^[^a-z]*$/, D = /* @__PURE__ */ a("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), ct = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, ut = /* @__PURE__ */ a("$ZodCheckLessThan", (e, t) => {
  D.init(e, t);
  const n = ct[typeof t.value];
  e._zod.onattach.push((o) => {
    const r = o._zod.bag, i = (t.inclusive ? r.maximum : r.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < i && (t.inclusive ? r.maximum = t.value : r.exclusiveMaximum = t.value);
  }), e._zod.check = (o) => {
    (t.inclusive ? o.value <= t.value : o.value < t.value) || o.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: o.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), at = /* @__PURE__ */ a("$ZodCheckGreaterThan", (e, t) => {
  D.init(e, t);
  const n = ct[typeof t.value];
  e._zod.onattach.push((o) => {
    const r = o._zod.bag, i = (t.inclusive ? r.minimum : r.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > i && (t.inclusive ? r.minimum = t.value : r.exclusiveMinimum = t.value);
  }), e._zod.check = (o) => {
    (t.inclusive ? o.value >= t.value : o.value > t.value) || o.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: o.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Sn = /* @__PURE__ */ a("$ZodCheckMultipleOf", (e, t) => {
  D.init(e, t), e._zod.onattach.push((n) => {
    var o;
    (o = n._zod.bag).multipleOf ?? (o.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : Et(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Zn = /* @__PURE__ */ a("$ZodCheckNumberFormat", (e, t) => {
  var s;
  D.init(e, t), t.format = t.format || "float64";
  const n = (s = t.format) == null ? void 0 : s.includes("int"), o = n ? "int" : "number", [r, i] = Dt[t.format];
  e._zod.onattach.push((c) => {
    const u = c._zod.bag;
    u.format = t.format, u.minimum = r, u.maximum = i, n && (u.pattern = bn);
  }), e._zod.check = (c) => {
    const u = c.value;
    if (n) {
      if (!Number.isInteger(u)) {
        c.issues.push({
          expected: o,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: u,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(u)) {
        u > 0 ? c.issues.push({
          input: u,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: o,
          inclusive: !0,
          continue: !t.abort
        }) : c.issues.push({
          input: u,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: o,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    u < r && c.issues.push({
      origin: "number",
      input: u,
      code: "too_small",
      minimum: r,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), u > i && c.issues.push({
      origin: "number",
      input: u,
      code: "too_big",
      maximum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), On = /* @__PURE__ */ a("$ZodCheckMaxLength", (e, t) => {
  var n;
  D.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const r = o.value;
    return !ye(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < r && (o._zod.bag.maximum = t.maximum);
  }), e._zod.check = (o) => {
    const r = o.value;
    if (r.length <= t.maximum)
      return;
    const s = be(r);
    o.issues.push({
      origin: s,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: r,
      inst: e,
      continue: !t.abort
    });
  };
}), En = /* @__PURE__ */ a("$ZodCheckMinLength", (e, t) => {
  var n;
  D.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const r = o.value;
    return !ye(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > r && (o._zod.bag.minimum = t.minimum);
  }), e._zod.check = (o) => {
    const r = o.value;
    if (r.length >= t.minimum)
      return;
    const s = be(r);
    o.issues.push({
      origin: s,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: r,
      inst: e,
      continue: !t.abort
    });
  };
}), Tn = /* @__PURE__ */ a("$ZodCheckLengthEquals", (e, t) => {
  var n;
  D.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const r = o.value;
    return !ye(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.minimum = t.length, r.maximum = t.length, r.length = t.length;
  }), e._zod.check = (o) => {
    const r = o.value, i = r.length;
    if (i === t.length)
      return;
    const s = be(r), c = i > t.length;
    o.issues.push({
      origin: s,
      ...c ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), he = /* @__PURE__ */ a("$ZodCheckStringFormat", (e, t) => {
  var n, o;
  D.init(e, t), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.format = t.format, t.pattern && (i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: r.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (o = e._zod).check ?? (o.check = () => {
  });
}), In = /* @__PURE__ */ a("$ZodCheckRegex", (e, t) => {
  he.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Pn = /* @__PURE__ */ a("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = kn), he.init(e, t);
}), Nn = /* @__PURE__ */ a("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = $n), he.init(e, t);
}), Dn = /* @__PURE__ */ a("$ZodCheckIncludes", (e, t) => {
  D.init(e, t);
  const n = q(t.includes), o = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = o, e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(o);
  }), e._zod.check = (r) => {
    r.value.includes(t.includes, t.position) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), An = /* @__PURE__ */ a("$ZodCheckStartsWith", (e, t) => {
  D.init(e, t);
  const n = new RegExp(`^${q(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(n);
  }), e._zod.check = (o) => {
    o.value.startsWith(t.prefix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), jn = /* @__PURE__ */ a("$ZodCheckEndsWith", (e, t) => {
  D.init(e, t);
  const n = new RegExp(`.*${q(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(n);
  }), e._zod.check = (o) => {
    o.value.endsWith(t.suffix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Cn = /* @__PURE__ */ a("$ZodCheckOverwrite", (e, t) => {
  D.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class Rn {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const o = t.split(`
`).filter((s) => s), r = Math.min(...o.map((s) => s.length - s.trimStart().length)), i = o.map((s) => s.slice(r)).map((s) => " ".repeat(this.indent * 2) + s);
    for (const s of i)
      this.content.push(s);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, r.join(`
`));
  }
}
const Fn = {
  major: 4,
  minor: 3,
  patch: 6
}, b = /* @__PURE__ */ a("$ZodType", (e, t) => {
  var r;
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Fn;
  const o = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && o.unshift(e);
  for (const i of o)
    for (const s of i._zod.onattach)
      s(e);
  if (o.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), (r = e._zod.deferred) == null || r.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const i = (c, u, l) => {
      let f = B(c), d;
      for (const g of u) {
        if (g._zod.def.when) {
          if (!g._zod.def.when(c))
            continue;
        } else if (f)
          continue;
        const _ = c.issues.length, z = g._zod.check(c);
        if (z instanceof Promise && (l == null ? void 0 : l.async) === !1)
          throw new W();
        if (d || z instanceof Promise)
          d = (d ?? Promise.resolve()).then(async () => {
            await z, c.issues.length !== _ && (f || (f = B(c, _)));
          });
        else {
          if (c.issues.length === _)
            continue;
          f || (f = B(c, _));
        }
      }
      return d ? d.then(() => c) : c;
    }, s = (c, u, l) => {
      if (B(c))
        return c.aborted = !0, c;
      const f = i(u, o, l);
      if (f instanceof Promise) {
        if (l.async === !1)
          throw new W();
        return f.then((d) => e._zod.parse(d, l));
      }
      return e._zod.parse(f, l);
    };
    e._zod.run = (c, u) => {
      if (u.skipChecks)
        return e._zod.parse(c, u);
      if (u.direction === "backward") {
        const f = e._zod.parse({ value: c.value, issues: [] }, { ...u, skipChecks: !0 });
        return f instanceof Promise ? f.then((d) => s(d, c, u)) : s(f, c, u);
      }
      const l = e._zod.parse(c, u);
      if (l instanceof Promise) {
        if (u.async === !1)
          throw new W();
        return l.then((f) => i(f, o, u));
      }
      return i(l, o, u);
    };
  }
  v(e, "~standard", () => ({
    validate: (i) => {
      var s;
      try {
        const c = Jt(e, i);
        return c.success ? { value: c.data } : { issues: (s = c.error) == null ? void 0 : s.issues };
      } catch {
        return Vt(e, i).then((u) => {
          var l;
          return u.success ? { value: u.data } : { issues: (l = u.error) == null ? void 0 : l.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), $e = /* @__PURE__ */ a("$ZodString", (e, t) => {
  var n;
  b.init(e, t), e._zod.pattern = [...((n = e == null ? void 0 : e._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? zn(e._zod.bag), e._zod.parse = (o, r) => {
    if (t.coerce)
      try {
        o.value = String(o.value);
      } catch {
      }
    return typeof o.value == "string" || o.issues.push({
      expected: "string",
      code: "invalid_type",
      input: o.value,
      inst: e
    }), o;
  };
}), k = /* @__PURE__ */ a("$ZodStringFormat", (e, t) => {
  he.init(e, t), $e.init(e, t);
}), Un = /* @__PURE__ */ a("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = cn), k.init(e, t);
}), xn = /* @__PURE__ */ a("$ZodUUID", (e, t) => {
  if (t.version) {
    const o = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (o === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Te(o));
  } else
    t.pattern ?? (t.pattern = Te());
  k.init(e, t);
}), Ln = /* @__PURE__ */ a("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = un), k.init(e, t);
}), Mn = /* @__PURE__ */ a("$ZodURL", (e, t) => {
  k.init(e, t), e._zod.check = (n) => {
    try {
      const o = n.value.trim(), r = new URL(o);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(r.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(r.protocol.endsWith(":") ? r.protocol.slice(0, -1) : r.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = r.href : n.value = o;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Jn = /* @__PURE__ */ a("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = ln()), k.init(e, t);
}), Vn = /* @__PURE__ */ a("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = rn), k.init(e, t);
}), Bn = /* @__PURE__ */ a("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Qt), k.init(e, t);
}), Kn = /* @__PURE__ */ a("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = en), k.init(e, t);
}), Wn = /* @__PURE__ */ a("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = tn), k.init(e, t);
}), Gn = /* @__PURE__ */ a("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = nn), k.init(e, t);
}), qn = /* @__PURE__ */ a("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = on), k.init(e, t);
}), Yn = /* @__PURE__ */ a("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = yn(t)), k.init(e, t);
}), Xn = /* @__PURE__ */ a("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = gn), k.init(e, t);
}), Hn = /* @__PURE__ */ a("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = vn(t)), k.init(e, t);
}), Qn = /* @__PURE__ */ a("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = sn), k.init(e, t);
}), eo = /* @__PURE__ */ a("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = fn), k.init(e, t), e._zod.bag.format = "ipv4";
}), to = /* @__PURE__ */ a("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = dn), k.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), no = /* @__PURE__ */ a("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = pn), k.init(e, t);
}), oo = /* @__PURE__ */ a("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = hn), k.init(e, t), e._zod.check = (n) => {
    const o = n.value.split("/");
    try {
      if (o.length !== 2)
        throw new Error();
      const [r, i] = o;
      if (!i)
        throw new Error();
      const s = Number(i);
      if (`${s}` !== i)
        throw new Error();
      if (s < 0 || s > 128)
        throw new Error();
      new URL(`http://[${r}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function lt(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const ro = /* @__PURE__ */ a("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = mn), k.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    lt(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function io(e) {
  if (!ot.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (o) => o === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return lt(n);
}
const so = /* @__PURE__ */ a("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = ot), k.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    io(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), co = /* @__PURE__ */ a("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = _n), k.init(e, t);
});
function uo(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [o] = n;
    if (!o)
      return !1;
    const r = JSON.parse(atob(o));
    return !("typ" in r && (r == null ? void 0 : r.typ) !== "JWT" || !r.alg || t && (!("alg" in r) || r.alg !== t));
  } catch {
    return !1;
  }
}
const ao = /* @__PURE__ */ a("$ZodJWT", (e, t) => {
  k.init(e, t), e._zod.check = (n) => {
    uo(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), ft = /* @__PURE__ */ a("$ZodNumber", (e, t) => {
  b.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? st, e._zod.parse = (n, o) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const r = n.value;
    if (typeof r == "number" && !Number.isNaN(r) && Number.isFinite(r))
      return n;
    const i = typeof r == "number" ? Number.isNaN(r) ? "NaN" : Number.isFinite(r) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: r,
      inst: e,
      ...i ? { received: i } : {}
    }), n;
  };
}), lo = /* @__PURE__ */ a("$ZodNumberFormat", (e, t) => {
  Zn.init(e, t), ft.init(e, t);
}), fo = /* @__PURE__ */ a("$ZodBoolean", (e, t) => {
  b.init(e, t), e._zod.pattern = wn, e._zod.parse = (n, o) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const r = n.value;
    return typeof r == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: r,
      inst: e
    }), n;
  };
}), po = /* @__PURE__ */ a("$ZodAny", (e, t) => {
  b.init(e, t), e._zod.parse = (n) => n;
}), ho = /* @__PURE__ */ a("$ZodUnknown", (e, t) => {
  b.init(e, t), e._zod.parse = (n) => n;
}), mo = /* @__PURE__ */ a("$ZodNever", (e, t) => {
  b.init(e, t), e._zod.parse = (n, o) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
}), _o = /* @__PURE__ */ a("$ZodDate", (e, t) => {
  b.init(e, t), e._zod.parse = (n, o) => {
    if (t.coerce)
      try {
        n.value = new Date(n.value);
      } catch {
      }
    const r = n.value, i = r instanceof Date;
    return i && !Number.isNaN(r.getTime()) || n.issues.push({
      expected: "date",
      code: "invalid_type",
      input: r,
      ...i ? { received: "Invalid Date" } : {},
      inst: e
    }), n;
  };
});
function Ie(e, t, n) {
  e.issues.length && t.issues.push(...K(n, e.issues)), t.value[n] = e.value;
}
const go = /* @__PURE__ */ a("$ZodArray", (e, t) => {
  b.init(e, t), e._zod.parse = (n, o) => {
    const r = n.value;
    if (!Array.isArray(r))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: r,
        inst: e
      }), n;
    n.value = Array(r.length);
    const i = [];
    for (let s = 0; s < r.length; s++) {
      const c = r[s], u = t.element._zod.run({
        value: c,
        issues: []
      }, o);
      u instanceof Promise ? i.push(u.then((l) => Ie(l, n, s))) : Ie(u, n, s);
    }
    return i.length ? Promise.all(i).then(() => n) : n;
  };
});
function ce(e, t, n, o, r) {
  if (e.issues.length) {
    if (r && !(n in o))
      return;
    t.issues.push(...K(n, e.issues));
  }
  e.value === void 0 ? n in o && (t.value[n] = void 0) : t.value[n] = e.value;
}
function dt(e) {
  var o, r, i, s;
  const t = Object.keys(e.shape);
  for (const c of t)
    if (!((s = (i = (r = (o = e.shape) == null ? void 0 : o[c]) == null ? void 0 : r._zod) == null ? void 0 : i.traits) != null && s.has("$ZodType")))
      throw new Error(`Invalid element at key "${c}": expected a Zod schema`);
  const n = Nt(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function pt(e, t, n, o, r, i) {
  const s = [], c = r.keySet, u = r.catchall._zod, l = u.def.type, f = u.optout === "optional";
  for (const d in t) {
    if (c.has(d))
      continue;
    if (l === "never") {
      s.push(d);
      continue;
    }
    const g = u.run({ value: t[d], issues: [] }, o);
    g instanceof Promise ? e.push(g.then((_) => ce(_, n, d, t, f))) : ce(g, n, d, t, f);
  }
  return s.length && n.issues.push({
    code: "unrecognized_keys",
    keys: s,
    input: t,
    inst: i
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const vo = /* @__PURE__ */ a("$ZodObject", (e, t) => {
  b.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const c = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const u = { ...c };
        return Object.defineProperty(t, "shape", {
          value: u
        }), u;
      }
    });
  }
  const o = ve(() => dt(t));
  v(e._zod, "propValues", () => {
    const c = t.shape, u = {};
    for (const l in c) {
      const f = c[l]._zod;
      if (f.values) {
        u[l] ?? (u[l] = /* @__PURE__ */ new Set());
        for (const d of f.values)
          u[l].add(d);
      }
    }
    return u;
  });
  const r = se, i = t.catchall;
  let s;
  e._zod.parse = (c, u) => {
    s ?? (s = o.value);
    const l = c.value;
    if (!r(l))
      return c.issues.push({
        expected: "object",
        code: "invalid_type",
        input: l,
        inst: e
      }), c;
    c.value = {};
    const f = [], d = s.shape;
    for (const g of s.keys) {
      const _ = d[g], z = _._zod.optout === "optional", y = _._zod.run({ value: l[g], issues: [] }, u);
      y instanceof Promise ? f.push(y.then((E) => ce(E, c, g, l, z))) : ce(y, c, g, l, z);
    }
    return i ? pt(f, l, c, u, o.value, e) : f.length ? Promise.all(f).then(() => c) : c;
  };
}), yo = /* @__PURE__ */ a("$ZodObjectJIT", (e, t) => {
  vo.init(e, t);
  const n = e._zod.parse, o = ve(() => dt(t)), r = (g) => {
    var ee;
    const _ = new Rn(["shape", "payload", "ctx"]), z = o.value, y = (R) => {
      const N = Ee(R);
      return `shape[${N}]._zod.run({ value: input[${N}], issues: [] }, ctx)`;
    };
    _.write("const input = payload.value;");
    const E = /* @__PURE__ */ Object.create(null);
    let X = 0;
    for (const R of z.keys)
      E[R] = `key_${X++}`;
    _.write("const newResult = {};");
    for (const R of z.keys) {
      const N = E[R], C = Ee(R), me = g[R], Ot = ((ee = me == null ? void 0 : me._zod) == null ? void 0 : ee.optout) === "optional";
      _.write(`const ${N} = ${y(R)};`), Ot ? _.write(`
        if (${N}.issues.length) {
          if (${C} in input) {
            payload.issues = payload.issues.concat(${N}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${C}, ...iss.path] : [${C}]
            })));
          }
        }
        
        if (${N}.value === undefined) {
          if (${C} in input) {
            newResult[${C}] = undefined;
          }
        } else {
          newResult[${C}] = ${N}.value;
        }
        
      `) : _.write(`
        if (${N}.issues.length) {
          payload.issues = payload.issues.concat(${N}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${C}, ...iss.path] : [${C}]
          })));
        }
        
        if (${N}.value === undefined) {
          if (${C} in input) {
            newResult[${C}] = undefined;
          }
        } else {
          newResult[${C}] = ${N}.value;
        }
        
      `);
    }
    _.write("payload.value = newResult;"), _.write("return payload;");
    const T = _.compile();
    return (R, N) => T(g, R, N);
  };
  let i;
  const s = se, c = !Ye.jitless, l = c && It.value, f = t.catchall;
  let d;
  e._zod.parse = (g, _) => {
    d ?? (d = o.value);
    const z = g.value;
    return s(z) ? c && l && (_ == null ? void 0 : _.async) === !1 && _.jitless !== !0 ? (i || (i = r(t.shape)), g = i(g, _), f ? pt([], z, g, _, d, e) : g) : n(g, _) : (g.issues.push({
      expected: "object",
      code: "invalid_type",
      input: z,
      inst: e
    }), g);
  };
});
function Pe(e, t, n, o) {
  for (const i of e)
    if (i.issues.length === 0)
      return t.value = i.value, t;
  const r = e.filter((i) => !B(i));
  return r.length === 1 ? (t.value = r[0].value, r[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((i) => i.issues.map((s) => x(s, o, U())))
  }), t);
}
const zo = /* @__PURE__ */ a("$ZodUnion", (e, t) => {
  b.init(e, t), v(e._zod, "optin", () => t.options.some((r) => r._zod.optin === "optional") ? "optional" : void 0), v(e._zod, "optout", () => t.options.some((r) => r._zod.optout === "optional") ? "optional" : void 0), v(e._zod, "values", () => {
    if (t.options.every((r) => r._zod.values))
      return new Set(t.options.flatMap((r) => Array.from(r._zod.values)));
  }), v(e._zod, "pattern", () => {
    if (t.options.every((r) => r._zod.pattern)) {
      const r = t.options.map((i) => i._zod.pattern);
      return new RegExp(`^(${r.map((i) => ze(i.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, o = t.options[0]._zod.run;
  e._zod.parse = (r, i) => {
    if (n)
      return o(r, i);
    let s = !1;
    const c = [];
    for (const u of t.options) {
      const l = u._zod.run({
        value: r.value,
        issues: []
      }, i);
      if (l instanceof Promise)
        c.push(l), s = !0;
      else {
        if (l.issues.length === 0)
          return l;
        c.push(l);
      }
    }
    return s ? Promise.all(c).then((u) => Pe(u, r, e, i)) : Pe(c, r, e, i);
  };
}), bo = /* @__PURE__ */ a("$ZodIntersection", (e, t) => {
  b.init(e, t), e._zod.parse = (n, o) => {
    const r = n.value, i = t.left._zod.run({ value: r, issues: [] }, o), s = t.right._zod.run({ value: r, issues: [] }, o);
    return i instanceof Promise || s instanceof Promise ? Promise.all([i, s]).then(([u, l]) => Ne(n, u, l)) : Ne(n, i, s);
  };
});
function ge(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (G(e) && G(t)) {
    const n = Object.keys(t), o = Object.keys(e).filter((i) => n.indexOf(i) !== -1), r = { ...e, ...t };
    for (const i of o) {
      const s = ge(e[i], t[i]);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [i, ...s.mergeErrorPath]
        };
      r[i] = s.data;
    }
    return { valid: !0, data: r };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let o = 0; o < e.length; o++) {
      const r = e[o], i = t[o], s = ge(r, i);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...s.mergeErrorPath]
        };
      n.push(s.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Ne(e, t, n) {
  const o = /* @__PURE__ */ new Map();
  let r;
  for (const c of t.issues)
    if (c.code === "unrecognized_keys") {
      r ?? (r = c);
      for (const u of c.keys)
        o.has(u) || o.set(u, {}), o.get(u).l = !0;
    } else
      e.issues.push(c);
  for (const c of n.issues)
    if (c.code === "unrecognized_keys")
      for (const u of c.keys)
        o.has(u) || o.set(u, {}), o.get(u).r = !0;
    else
      e.issues.push(c);
  const i = [...o].filter(([, c]) => c.l && c.r).map(([c]) => c);
  if (i.length && r && e.issues.push({ ...r, keys: i }), B(e))
    return e;
  const s = ge(t.value, n.value);
  if (!s.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(s.mergeErrorPath)}`);
  return e.value = s.data, e;
}
const wo = /* @__PURE__ */ a("$ZodRecord", (e, t) => {
  b.init(e, t), e._zod.parse = (n, o) => {
    const r = n.value;
    if (!G(r))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: r,
        inst: e
      }), n;
    const i = [], s = t.keyType._zod.values;
    if (s) {
      n.value = {};
      const c = /* @__PURE__ */ new Set();
      for (const l of s)
        if (typeof l == "string" || typeof l == "number" || typeof l == "symbol") {
          c.add(typeof l == "number" ? l.toString() : l);
          const f = t.valueType._zod.run({ value: r[l], issues: [] }, o);
          f instanceof Promise ? i.push(f.then((d) => {
            d.issues.length && n.issues.push(...K(l, d.issues)), n.value[l] = d.value;
          })) : (f.issues.length && n.issues.push(...K(l, f.issues)), n.value[l] = f.value);
        }
      let u;
      for (const l in r)
        c.has(l) || (u = u ?? [], u.push(l));
      u && u.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: r,
        inst: e,
        keys: u
      });
    } else {
      n.value = {};
      for (const c of Reflect.ownKeys(r)) {
        if (c === "__proto__")
          continue;
        let u = t.keyType._zod.run({ value: c, issues: [] }, o);
        if (u instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (typeof c == "string" && st.test(c) && u.issues.length) {
          const d = t.keyType._zod.run({ value: Number(c), issues: [] }, o);
          if (d instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          d.issues.length === 0 && (u = d);
        }
        if (u.issues.length) {
          t.mode === "loose" ? n.value[c] = r[c] : n.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: u.issues.map((d) => x(d, o, U())),
            input: c,
            path: [c],
            inst: e
          });
          continue;
        }
        const f = t.valueType._zod.run({ value: r[c], issues: [] }, o);
        f instanceof Promise ? i.push(f.then((d) => {
          d.issues.length && n.issues.push(...K(c, d.issues)), n.value[u.value] = d.value;
        })) : (f.issues.length && n.issues.push(...K(c, f.issues)), n.value[u.value] = f.value);
      }
    }
    return i.length ? Promise.all(i).then(() => n) : n;
  };
}), ko = /* @__PURE__ */ a("$ZodEnum", (e, t) => {
  b.init(e, t);
  const n = Xe(t.entries), o = new Set(n);
  e._zod.values = o, e._zod.pattern = new RegExp(`^(${n.filter((r) => Pt.has(typeof r)).map((r) => typeof r == "string" ? q(r) : r.toString()).join("|")})$`), e._zod.parse = (r, i) => {
    const s = r.value;
    return o.has(s) || r.issues.push({
      code: "invalid_value",
      values: n,
      input: s,
      inst: e
    }), r;
  };
}), $o = /* @__PURE__ */ a("$ZodLiteral", (e, t) => {
  if (b.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const n = new Set(t.values);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${t.values.map((o) => typeof o == "string" ? q(o) : o ? q(o.toString()) : String(o)).join("|")})$`), e._zod.parse = (o, r) => {
    const i = o.value;
    return n.has(i) || o.issues.push({
      code: "invalid_value",
      values: t.values,
      input: i,
      inst: e
    }), o;
  };
}), So = /* @__PURE__ */ a("$ZodTransform", (e, t) => {
  b.init(e, t), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      throw new qe(e.constructor.name);
    const r = t.transform(n.value, n);
    if (o.async)
      return (r instanceof Promise ? r : Promise.resolve(r)).then((s) => (n.value = s, n));
    if (r instanceof Promise)
      throw new W();
    return n.value = r, n;
  };
});
function De(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const ht = /* @__PURE__ */ a("$ZodOptional", (e, t) => {
  b.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", v(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), v(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${ze(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, o) => {
    if (t.innerType._zod.optin === "optional") {
      const r = t.innerType._zod.run(n, o);
      return r instanceof Promise ? r.then((i) => De(i, n.value)) : De(r, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, o);
  };
}), Zo = /* @__PURE__ */ a("$ZodExactOptional", (e, t) => {
  ht.init(e, t), v(e._zod, "values", () => t.innerType._zod.values), v(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, o) => t.innerType._zod.run(n, o);
}), Oo = /* @__PURE__ */ a("$ZodNullable", (e, t) => {
  b.init(e, t), v(e._zod, "optin", () => t.innerType._zod.optin), v(e._zod, "optout", () => t.innerType._zod.optout), v(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${ze(n.source)}|null)$`) : void 0;
  }), v(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, o) => n.value === null ? n : t.innerType._zod.run(n, o);
}), Eo = /* @__PURE__ */ a("$ZodDefault", (e, t) => {
  b.init(e, t), e._zod.optin = "optional", v(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(n, o);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => Ae(i, t)) : Ae(r, t);
  };
});
function Ae(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const To = /* @__PURE__ */ a("$ZodPrefault", (e, t) => {
  b.init(e, t), e._zod.optin = "optional", v(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => (o.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, o));
}), Io = /* @__PURE__ */ a("$ZodNonOptional", (e, t) => {
  b.init(e, t), v(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (n, o) => {
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => je(i, e)) : je(r, e);
  };
});
function je(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Po = /* @__PURE__ */ a("$ZodCatch", (e, t) => {
  b.init(e, t), v(e._zod, "optin", () => t.innerType._zod.optin), v(e._zod, "optout", () => t.innerType._zod.optout), v(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(n, o);
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((s) => x(s, o, U()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = r.value, r.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: r.issues.map((i) => x(i, o, U()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), No = /* @__PURE__ */ a("$ZodPipe", (e, t) => {
  b.init(e, t), v(e._zod, "values", () => t.in._zod.values), v(e._zod, "optin", () => t.in._zod.optin), v(e._zod, "optout", () => t.out._zod.optout), v(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, o) => {
    if (o.direction === "backward") {
      const i = t.out._zod.run(n, o);
      return i instanceof Promise ? i.then((s) => ne(s, t.in, o)) : ne(i, t.in, o);
    }
    const r = t.in._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => ne(i, t.out, o)) : ne(r, t.out, o);
  };
});
function ne(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const Do = /* @__PURE__ */ a("$ZodReadonly", (e, t) => {
  b.init(e, t), v(e._zod, "propValues", () => t.innerType._zod.propValues), v(e._zod, "values", () => t.innerType._zod.values), v(e._zod, "optin", () => {
    var n, o;
    return (o = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : o.optin;
  }), v(e._zod, "optout", () => {
    var n, o;
    return (o = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : o.optout;
  }), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(n, o);
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then(Ce) : Ce(r);
  };
});
function Ce(e) {
  return e.value = Object.freeze(e.value), e;
}
const Ao = /* @__PURE__ */ a("$ZodLazy", (e, t) => {
  b.init(e, t), v(e._zod, "innerType", () => t.getter()), v(e._zod, "pattern", () => {
    var n, o;
    return (o = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : o.pattern;
  }), v(e._zod, "propValues", () => {
    var n, o;
    return (o = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : o.propValues;
  }), v(e._zod, "optin", () => {
    var n, o;
    return ((o = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : o.optin) ?? void 0;
  }), v(e._zod, "optout", () => {
    var n, o;
    return ((o = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : o.optout) ?? void 0;
  }), e._zod.parse = (n, o) => e._zod.innerType._zod.run(n, o);
}), jo = /* @__PURE__ */ a("$ZodCustom", (e, t) => {
  D.init(e, t), b.init(e, t), e._zod.parse = (n, o) => n, e._zod.check = (n) => {
    const o = n.value, r = t.fn(o);
    if (r instanceof Promise)
      return r.then((i) => Re(i, n, o, e));
    Re(r, n, o, e);
  };
});
function Re(e, t, n, o) {
  if (!e) {
    const r = {
      code: "custom",
      input: n,
      inst: o,
      // incorporates params.error into issue reporting
      path: [...o._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !o._zod.def.abort
      // params: inst._zod.def.params,
    };
    o._zod.def.params && (r.params = o._zod.def.params), t.issues.push(Q(r));
  }
}
var Fe;
class Co {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const o = n[0];
    return this._map.set(t, o), o && typeof o == "object" && "id" in o && this._idmap.set(o.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const o = { ...this.get(n) ?? {} };
      delete o.id;
      const r = { ...o, ...this._map.get(t) };
      return Object.keys(r).length ? r : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Ro() {
  return new Co();
}
(Fe = globalThis).__zod_globalRegistry ?? (Fe.__zod_globalRegistry = Ro());
const H = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function Fo(e, t) {
  return new e({
    type: "string",
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Uo(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ue(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xo(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Lo(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Mo(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Jo(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Vo(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Bo(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ko(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Wo(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Go(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qo(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Yo(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Xo(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ho(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Qo(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function er(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tr(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nr(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function or(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rr(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ir(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sr(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cr(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ur(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ar(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lr(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fr(e, t) {
  return new e({
    type: "number",
    coerce: !0,
    checks: [],
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dr(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pr(e, t) {
  return new e({
    type: "boolean",
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hr(e) {
  return new e({
    type: "any"
  });
}
// @__NO_SIDE_EFFECTS__
function mr(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function _r(e, t) {
  return new e({
    type: "never",
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function gr(e, t) {
  return new e({
    type: "date",
    ...h(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xe(e, t) {
  return new ut({
    check: "less_than",
    ...h(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function re(e, t) {
  return new ut({
    check: "less_than",
    ...h(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Le(e, t) {
  return new at({
    check: "greater_than",
    ...h(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function ie(e, t) {
  return new at({
    check: "greater_than",
    ...h(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Me(e, t) {
  return new Sn({
    check: "multiple_of",
    ...h(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function mt(e, t) {
  return new On({
    check: "max_length",
    ...h(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function ue(e, t) {
  return new En({
    check: "min_length",
    ...h(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function _t(e, t) {
  return new Tn({
    check: "length_equals",
    ...h(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function vr(e, t) {
  return new In({
    check: "string_format",
    format: "regex",
    ...h(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function yr(e) {
  return new Pn({
    check: "string_format",
    format: "lowercase",
    ...h(e)
  });
}
// @__NO_SIDE_EFFECTS__
function zr(e) {
  return new Nn({
    check: "string_format",
    format: "uppercase",
    ...h(e)
  });
}
// @__NO_SIDE_EFFECTS__
function br(e, t) {
  return new Dn({
    check: "string_format",
    format: "includes",
    ...h(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function wr(e, t) {
  return new An({
    check: "string_format",
    format: "starts_with",
    ...h(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function kr(e, t) {
  return new jn({
    check: "string_format",
    format: "ends_with",
    ...h(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Y(e) {
  return new Cn({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function $r(e) {
  return /* @__PURE__ */ Y((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function Sr() {
  return /* @__PURE__ */ Y((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function Zr() {
  return /* @__PURE__ */ Y((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Or() {
  return /* @__PURE__ */ Y((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Er() {
  return /* @__PURE__ */ Y((e) => Tt(e));
}
// @__NO_SIDE_EFFECTS__
function Tr(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...h(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Ir(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...h(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Pr(e) {
  const t = /* @__PURE__ */ Nr((n) => (n.addIssue = (o) => {
    if (typeof o == "string")
      n.issues.push(Q(o, n.value, t._zod.def));
    else {
      const r = o;
      r.fatal && (r.continue = !1), r.code ?? (r.code = "custom"), r.input ?? (r.input = n.value), r.inst ?? (r.inst = t), r.continue ?? (r.continue = !t._zod.def.abort), n.issues.push(Q(r));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function Nr(e, t) {
  const n = new D({
    check: "custom",
    ...h(t)
  });
  return n._zod.check = e, n;
}
function gt(e) {
  let t = (e == null ? void 0 : e.target) ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: (e == null ? void 0 : e.metadata) ?? H,
    target: t,
    unrepresentable: (e == null ? void 0 : e.unrepresentable) ?? "throw",
    override: (e == null ? void 0 : e.override) ?? (() => {
    }),
    io: (e == null ? void 0 : e.io) ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: (e == null ? void 0 : e.cycles) ?? "ref",
    reused: (e == null ? void 0 : e.reused) ?? "inline",
    external: (e == null ? void 0 : e.external) ?? void 0
  };
}
function Z(e, t, n = { path: [], schemaPath: [] }) {
  var f, d;
  var o;
  const r = e._zod.def, i = t.seen.get(e);
  if (i)
    return i.count++, n.schemaPath.includes(e) && (i.cycle = n.path), i.schema;
  const s = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, s);
  const c = (d = (f = e._zod).toJSONSchema) == null ? void 0 : d.call(f);
  if (c)
    s.schema = c;
  else {
    const g = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, s.schema, g);
    else {
      const z = s.schema, y = t.processors[r.type];
      if (!y)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${r.type}`);
      y(e, t, z, g);
    }
    const _ = e._zod.parent;
    _ && (s.ref || (s.ref = _), Z(_, t, g), t.seen.get(_).isParent = !0);
  }
  const u = t.metadataRegistry.get(e);
  return u && Object.assign(s.schema, u), t.io === "input" && P(e) && (delete s.schema.examples, delete s.schema.default), t.io === "input" && s.schema._prefault && ((o = s.schema).default ?? (o.default = s.schema._prefault)), delete s.schema._prefault, t.seen.get(e).schema;
}
function vt(e, t) {
  var s, c, u, l;
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const o = /* @__PURE__ */ new Map();
  for (const f of e.seen.entries()) {
    const d = (s = e.metadataRegistry.get(f[0])) == null ? void 0 : s.id;
    if (d) {
      const g = o.get(d);
      if (g && g !== f[0])
        throw new Error(`Duplicate schema id "${d}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      o.set(d, f[0]);
    }
  }
  const r = (f) => {
    var y;
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const E = (y = e.external.registry.get(f[0])) == null ? void 0 : y.id, X = e.external.uri ?? ((ee) => ee);
      if (E)
        return { ref: X(E) };
      const T = f[1].defId ?? f[1].schema.id ?? `schema${e.counter++}`;
      return f[1].defId = T, { defId: T, ref: `${X("__shared")}#/${d}/${T}` };
    }
    if (f[1] === n)
      return { ref: "#" };
    const _ = `#/${d}/`, z = f[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: z, ref: _ + z };
  }, i = (f) => {
    if (f[1].schema.$ref)
      return;
    const d = f[1], { ref: g, defId: _ } = r(f);
    d.def = { ...d.schema }, _ && (d.defId = _);
    const z = d.schema;
    for (const y in z)
      delete z[y];
    z.$ref = g;
  };
  if (e.cycles === "throw")
    for (const f of e.seen.entries()) {
      const d = f[1];
      if (d.cycle)
        throw new Error(`Cycle detected: #/${(c = d.cycle) == null ? void 0 : c.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const f of e.seen.entries()) {
    const d = f[1];
    if (t === f[0]) {
      i(f);
      continue;
    }
    if (e.external) {
      const _ = (u = e.external.registry.get(f[0])) == null ? void 0 : u.id;
      if (t !== f[0] && _) {
        i(f);
        continue;
      }
    }
    if ((l = e.metadataRegistry.get(f[0])) == null ? void 0 : l.id) {
      i(f);
      continue;
    }
    if (d.cycle) {
      i(f);
      continue;
    }
    if (d.count > 1 && e.reused === "ref") {
      i(f);
      continue;
    }
  }
}
function yt(e, t) {
  var s, c, u;
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const o = (l) => {
    const f = e.seen.get(l);
    if (f.ref === null)
      return;
    const d = f.def ?? f.schema, g = { ...d }, _ = f.ref;
    if (f.ref = null, _) {
      o(_);
      const y = e.seen.get(_), E = y.schema;
      if (E.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (d.allOf = d.allOf ?? [], d.allOf.push(E)) : Object.assign(d, E), Object.assign(d, g), l._zod.parent === _)
        for (const T in d)
          T === "$ref" || T === "allOf" || T in g || delete d[T];
      if (E.$ref && y.def)
        for (const T in d)
          T === "$ref" || T === "allOf" || T in y.def && JSON.stringify(d[T]) === JSON.stringify(y.def[T]) && delete d[T];
    }
    const z = l._zod.parent;
    if (z && z !== _) {
      o(z);
      const y = e.seen.get(z);
      if (y != null && y.schema.$ref && (d.$ref = y.schema.$ref, y.def))
        for (const E in d)
          E === "$ref" || E === "allOf" || E in y.def && JSON.stringify(d[E]) === JSON.stringify(y.def[E]) && delete d[E];
    }
    e.override({
      zodSchema: l,
      jsonSchema: d,
      path: f.path ?? []
    });
  };
  for (const l of [...e.seen.entries()].reverse())
    o(l[0]);
  const r = {};
  if (e.target === "draft-2020-12" ? r.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? r.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? r.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (s = e.external) != null && s.uri) {
    const l = (c = e.external.registry.get(t)) == null ? void 0 : c.id;
    if (!l)
      throw new Error("Schema is missing an `id` property");
    r.$id = e.external.uri(l);
  }
  Object.assign(r, n.def ?? n.schema);
  const i = ((u = e.external) == null ? void 0 : u.defs) ?? {};
  for (const l of e.seen.entries()) {
    const f = l[1];
    f.def && f.defId && (i[f.defId] = f.def);
  }
  e.external || Object.keys(i).length > 0 && (e.target === "draft-2020-12" ? r.$defs = i : r.definitions = i);
  try {
    const l = JSON.parse(JSON.stringify(r));
    return Object.defineProperty(l, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: ae(t, "input", e.processors),
          output: ae(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), l;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function P(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const o = e._zod.def;
  if (o.type === "transform")
    return !0;
  if (o.type === "array")
    return P(o.element, n);
  if (o.type === "set")
    return P(o.valueType, n);
  if (o.type === "lazy")
    return P(o.getter(), n);
  if (o.type === "promise" || o.type === "optional" || o.type === "nonoptional" || o.type === "nullable" || o.type === "readonly" || o.type === "default" || o.type === "prefault")
    return P(o.innerType, n);
  if (o.type === "intersection")
    return P(o.left, n) || P(o.right, n);
  if (o.type === "record" || o.type === "map")
    return P(o.keyType, n) || P(o.valueType, n);
  if (o.type === "pipe")
    return P(o.in, n) || P(o.out, n);
  if (o.type === "object") {
    for (const r in o.shape)
      if (P(o.shape[r], n))
        return !0;
    return !1;
  }
  if (o.type === "union") {
    for (const r of o.options)
      if (P(r, n))
        return !0;
    return !1;
  }
  if (o.type === "tuple") {
    for (const r of o.items)
      if (P(r, n))
        return !0;
    return !!(o.rest && P(o.rest, n));
  }
  return !1;
}
const Dr = (e, t = {}) => (n) => {
  const o = gt({ ...n, processors: t });
  return Z(e, o), vt(o, e), yt(o, e);
}, ae = (e, t, n = {}) => (o) => {
  const { libraryOptions: r, target: i } = o ?? {}, s = gt({ ...r ?? {}, target: i, io: t, processors: n });
  return Z(e, s), vt(s, e), yt(s, e);
}, Ar = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, jr = (e, t, n, o) => {
  const r = n;
  r.type = "string";
  const { minimum: i, maximum: s, format: c, patterns: u, contentEncoding: l } = e._zod.bag;
  if (typeof i == "number" && (r.minLength = i), typeof s == "number" && (r.maxLength = s), c && (r.format = Ar[c] ?? c, r.format === "" && delete r.format, c === "time" && delete r.format), l && (r.contentEncoding = l), u && u.size > 0) {
    const f = [...u];
    f.length === 1 ? r.pattern = f[0].source : f.length > 1 && (r.allOf = [
      ...f.map((d) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: d.source
      }))
    ]);
  }
}, Cr = (e, t, n, o) => {
  const r = n, { minimum: i, maximum: s, format: c, multipleOf: u, exclusiveMaximum: l, exclusiveMinimum: f } = e._zod.bag;
  typeof c == "string" && c.includes("int") ? r.type = "integer" : r.type = "number", typeof f == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (r.minimum = f, r.exclusiveMinimum = !0) : r.exclusiveMinimum = f), typeof i == "number" && (r.minimum = i, typeof f == "number" && t.target !== "draft-04" && (f >= i ? delete r.minimum : delete r.exclusiveMinimum)), typeof l == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (r.maximum = l, r.exclusiveMaximum = !0) : r.exclusiveMaximum = l), typeof s == "number" && (r.maximum = s, typeof l == "number" && t.target !== "draft-04" && (l <= s ? delete r.maximum : delete r.exclusiveMaximum)), typeof u == "number" && (r.multipleOf = u);
}, Rr = (e, t, n, o) => {
  n.type = "boolean";
}, Fr = (e, t, n, o) => {
  n.not = {};
}, Ur = (e, t, n, o) => {
}, xr = (e, t, n, o) => {
}, Lr = (e, t, n, o) => {
  if (t.unrepresentable === "throw")
    throw new Error("Date cannot be represented in JSON Schema");
}, Mr = (e, t, n, o) => {
  const r = e._zod.def, i = Xe(r.entries);
  i.every((s) => typeof s == "number") && (n.type = "number"), i.every((s) => typeof s == "string") && (n.type = "string"), n.enum = i;
}, Jr = (e, t, n, o) => {
  const r = e._zod.def, i = [];
  for (const s of r.values)
    if (s === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof s == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      i.push(Number(s));
    } else
      i.push(s);
  if (i.length !== 0) if (i.length === 1) {
    const s = i[0];
    n.type = s === null ? "null" : typeof s, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [s] : n.const = s;
  } else
    i.every((s) => typeof s == "number") && (n.type = "number"), i.every((s) => typeof s == "string") && (n.type = "string"), i.every((s) => typeof s == "boolean") && (n.type = "boolean"), i.every((s) => s === null) && (n.type = "null"), n.enum = i;
}, Vr = (e, t, n, o) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Br = (e, t, n, o) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Kr = (e, t, n, o) => {
  const r = n, i = e._zod.def, { minimum: s, maximum: c } = e._zod.bag;
  typeof s == "number" && (r.minItems = s), typeof c == "number" && (r.maxItems = c), r.type = "array", r.items = Z(i.element, t, { ...o, path: [...o.path, "items"] });
}, Wr = (e, t, n, o) => {
  var l;
  const r = n, i = e._zod.def;
  r.type = "object", r.properties = {};
  const s = i.shape;
  for (const f in s)
    r.properties[f] = Z(s[f], t, {
      ...o,
      path: [...o.path, "properties", f]
    });
  const c = new Set(Object.keys(s)), u = new Set([...c].filter((f) => {
    const d = i.shape[f]._zod;
    return t.io === "input" ? d.optin === void 0 : d.optout === void 0;
  }));
  u.size > 0 && (r.required = Array.from(u)), ((l = i.catchall) == null ? void 0 : l._zod.def.type) === "never" ? r.additionalProperties = !1 : i.catchall ? i.catchall && (r.additionalProperties = Z(i.catchall, t, {
    ...o,
    path: [...o.path, "additionalProperties"]
  })) : t.io === "output" && (r.additionalProperties = !1);
}, Gr = (e, t, n, o) => {
  const r = e._zod.def, i = r.inclusive === !1, s = r.options.map((c, u) => Z(c, t, {
    ...o,
    path: [...o.path, i ? "oneOf" : "anyOf", u]
  }));
  i ? n.oneOf = s : n.anyOf = s;
}, qr = (e, t, n, o) => {
  const r = e._zod.def, i = Z(r.left, t, {
    ...o,
    path: [...o.path, "allOf", 0]
  }), s = Z(r.right, t, {
    ...o,
    path: [...o.path, "allOf", 1]
  }), c = (l) => "allOf" in l && Object.keys(l).length === 1, u = [
    ...c(i) ? i.allOf : [i],
    ...c(s) ? s.allOf : [s]
  ];
  n.allOf = u;
}, Yr = (e, t, n, o) => {
  const r = n, i = e._zod.def;
  r.type = "object";
  const s = i.keyType, c = s._zod.bag, u = c == null ? void 0 : c.patterns;
  if (i.mode === "loose" && u && u.size > 0) {
    const f = Z(i.valueType, t, {
      ...o,
      path: [...o.path, "patternProperties", "*"]
    });
    r.patternProperties = {};
    for (const d of u)
      r.patternProperties[d.source] = f;
  } else
    (t.target === "draft-07" || t.target === "draft-2020-12") && (r.propertyNames = Z(i.keyType, t, {
      ...o,
      path: [...o.path, "propertyNames"]
    })), r.additionalProperties = Z(i.valueType, t, {
      ...o,
      path: [...o.path, "additionalProperties"]
    });
  const l = s._zod.values;
  if (l) {
    const f = [...l].filter((d) => typeof d == "string" || typeof d == "number");
    f.length > 0 && (r.required = f);
  }
}, Xr = (e, t, n, o) => {
  const r = e._zod.def, i = Z(r.innerType, t, o), s = t.seen.get(e);
  t.target === "openapi-3.0" ? (s.ref = r.innerType, n.nullable = !0) : n.anyOf = [i, { type: "null" }];
}, Hr = (e, t, n, o) => {
  const r = e._zod.def;
  Z(r.innerType, t, o);
  const i = t.seen.get(e);
  i.ref = r.innerType;
}, Qr = (e, t, n, o) => {
  const r = e._zod.def;
  Z(r.innerType, t, o);
  const i = t.seen.get(e);
  i.ref = r.innerType, n.default = JSON.parse(JSON.stringify(r.defaultValue));
}, ei = (e, t, n, o) => {
  const r = e._zod.def;
  Z(r.innerType, t, o);
  const i = t.seen.get(e);
  i.ref = r.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(r.defaultValue)));
}, ti = (e, t, n, o) => {
  const r = e._zod.def;
  Z(r.innerType, t, o);
  const i = t.seen.get(e);
  i.ref = r.innerType;
  let s;
  try {
    s = r.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = s;
}, ni = (e, t, n, o) => {
  const r = e._zod.def, i = t.io === "input" ? r.in._zod.def.type === "transform" ? r.out : r.in : r.out;
  Z(i, t, o);
  const s = t.seen.get(e);
  s.ref = i;
}, oi = (e, t, n, o) => {
  const r = e._zod.def;
  Z(r.innerType, t, o);
  const i = t.seen.get(e);
  i.ref = r.innerType, n.readOnly = !0;
}, zt = (e, t, n, o) => {
  const r = e._zod.def;
  Z(r.innerType, t, o);
  const i = t.seen.get(e);
  i.ref = r.innerType;
}, ri = (e, t, n, o) => {
  const r = e._zod.innerType;
  Z(r, t, o);
  const i = t.seen.get(e);
  i.ref = r;
}, ii = /* @__PURE__ */ a("ZodISODateTime", (e, t) => {
  Yn.init(e, t), S.init(e, t);
});
function si(e) {
  return /* @__PURE__ */ sr(ii, e);
}
const ci = /* @__PURE__ */ a("ZodISODate", (e, t) => {
  Xn.init(e, t), S.init(e, t);
});
function ui(e) {
  return /* @__PURE__ */ cr(ci, e);
}
const ai = /* @__PURE__ */ a("ZodISOTime", (e, t) => {
  Hn.init(e, t), S.init(e, t);
});
function li(e) {
  return /* @__PURE__ */ ur(ai, e);
}
const fi = /* @__PURE__ */ a("ZodISODuration", (e, t) => {
  Qn.init(e, t), S.init(e, t);
});
function di(e) {
  return /* @__PURE__ */ ar(fi, e);
}
const pi = (e, t) => {
  tt.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => Mt(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => Lt(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, _e, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, _e, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, j = a("ZodError", pi, {
  Parent: Error
}), hi = /* @__PURE__ */ we(j), mi = /* @__PURE__ */ ke(j), _i = /* @__PURE__ */ de(j), gi = /* @__PURE__ */ pe(j), vi = /* @__PURE__ */ Bt(j), yi = /* @__PURE__ */ Kt(j), zi = /* @__PURE__ */ Wt(j), bi = /* @__PURE__ */ Gt(j), wi = /* @__PURE__ */ qt(j), ki = /* @__PURE__ */ Yt(j), $i = /* @__PURE__ */ Xt(j), Si = /* @__PURE__ */ Ht(j), w = /* @__PURE__ */ a("ZodType", (e, t) => (b.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: ae(e, "input"),
    output: ae(e, "output")
  }
}), e.toJSONSchema = Dr(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(L(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, o) => M(e, n, o), e.brand = () => e, e.register = ((n, o) => (n.add(e, o), e)), e.parse = (n, o) => hi(e, n, o, { callee: e.parse }), e.safeParse = (n, o) => _i(e, n, o), e.parseAsync = async (n, o) => mi(e, n, o, { callee: e.parseAsync }), e.safeParseAsync = async (n, o) => gi(e, n, o), e.spa = e.safeParseAsync, e.encode = (n, o) => vi(e, n, o), e.decode = (n, o) => yi(e, n, o), e.encodeAsync = async (n, o) => zi(e, n, o), e.decodeAsync = async (n, o) => bi(e, n, o), e.safeEncode = (n, o) => wi(e, n, o), e.safeDecode = (n, o) => ki(e, n, o), e.safeEncodeAsync = async (n, o) => $i(e, n, o), e.safeDecodeAsync = async (n, o) => Si(e, n, o), e.refine = (n, o) => e.check(Ss(n, o)), e.superRefine = (n) => e.check(Zs(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ Y(n)), e.optional = () => Ke(e), e.exactOptional = () => fs(e), e.nullable = () => We(e), e.nullish = () => Ke(We(e)), e.nonoptional = (n) => gs(e, n), e.array = () => O(e), e.or = (n) => F([e, n]), e.and = (n) => os(e, n), e.transform = (n) => Ge(e, as(n)), e.default = (n) => hs(e, n), e.prefault = (n) => _s(e, n), e.catch = (n) => ys(e, n), e.pipe = (n) => Ge(e, n), e.readonly = () => ws(e), e.describe = (n) => {
  const o = e.clone();
  return H.add(o, { description: n }), o;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = H.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return H.get(e);
  const o = e.clone();
  return H.add(o, n[0]), o;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), bt = /* @__PURE__ */ a("_ZodString", (e, t) => {
  $e.init(e, t), w.init(e, t), e._zod.processJSONSchema = (o, r, i) => jr(e, o, r);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...o) => e.check(/* @__PURE__ */ vr(...o)), e.includes = (...o) => e.check(/* @__PURE__ */ br(...o)), e.startsWith = (...o) => e.check(/* @__PURE__ */ wr(...o)), e.endsWith = (...o) => e.check(/* @__PURE__ */ kr(...o)), e.min = (...o) => e.check(/* @__PURE__ */ ue(...o)), e.max = (...o) => e.check(/* @__PURE__ */ mt(...o)), e.length = (...o) => e.check(/* @__PURE__ */ _t(...o)), e.nonempty = (...o) => e.check(/* @__PURE__ */ ue(1, ...o)), e.lowercase = (o) => e.check(/* @__PURE__ */ yr(o)), e.uppercase = (o) => e.check(/* @__PURE__ */ zr(o)), e.trim = () => e.check(/* @__PURE__ */ Sr()), e.normalize = (...o) => e.check(/* @__PURE__ */ $r(...o)), e.toLowerCase = () => e.check(/* @__PURE__ */ Zr()), e.toUpperCase = () => e.check(/* @__PURE__ */ Or()), e.slugify = () => e.check(/* @__PURE__ */ Er());
}), Zi = /* @__PURE__ */ a("ZodString", (e, t) => {
  $e.init(e, t), bt.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ Uo(Oi, n)), e.url = (n) => e.check(/* @__PURE__ */ Vo(Ei, n)), e.jwt = (n) => e.check(/* @__PURE__ */ ir(Ji, n)), e.emoji = (n) => e.check(/* @__PURE__ */ Bo(Ti, n)), e.guid = (n) => e.check(/* @__PURE__ */ Ue(Je, n)), e.uuid = (n) => e.check(/* @__PURE__ */ xo(oe, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ Lo(oe, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ Mo(oe, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ Jo(oe, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ Ko(Ii, n)), e.guid = (n) => e.check(/* @__PURE__ */ Ue(Je, n)), e.cuid = (n) => e.check(/* @__PURE__ */ Wo(Pi, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ Go(Ni, n)), e.ulid = (n) => e.check(/* @__PURE__ */ qo(Di, n)), e.base64 = (n) => e.check(/* @__PURE__ */ nr(xi, n)), e.base64url = (n) => e.check(/* @__PURE__ */ or(Li, n)), e.xid = (n) => e.check(/* @__PURE__ */ Yo(Ai, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ Xo(ji, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ Ho(Ci, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ Qo(Ri, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ er(Fi, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ tr(Ui, n)), e.e164 = (n) => e.check(/* @__PURE__ */ rr(Mi, n)), e.datetime = (n) => e.check(si(n)), e.date = (n) => e.check(ui(n)), e.time = (n) => e.check(li(n)), e.duration = (n) => e.check(di(n));
});
function p(e) {
  return /* @__PURE__ */ Fo(Zi, e);
}
const S = /* @__PURE__ */ a("ZodStringFormat", (e, t) => {
  k.init(e, t), bt.init(e, t);
}), Oi = /* @__PURE__ */ a("ZodEmail", (e, t) => {
  Ln.init(e, t), S.init(e, t);
}), Je = /* @__PURE__ */ a("ZodGUID", (e, t) => {
  Un.init(e, t), S.init(e, t);
}), oe = /* @__PURE__ */ a("ZodUUID", (e, t) => {
  xn.init(e, t), S.init(e, t);
}), Ei = /* @__PURE__ */ a("ZodURL", (e, t) => {
  Mn.init(e, t), S.init(e, t);
}), Ti = /* @__PURE__ */ a("ZodEmoji", (e, t) => {
  Jn.init(e, t), S.init(e, t);
}), Ii = /* @__PURE__ */ a("ZodNanoID", (e, t) => {
  Vn.init(e, t), S.init(e, t);
}), Pi = /* @__PURE__ */ a("ZodCUID", (e, t) => {
  Bn.init(e, t), S.init(e, t);
}), Ni = /* @__PURE__ */ a("ZodCUID2", (e, t) => {
  Kn.init(e, t), S.init(e, t);
}), Di = /* @__PURE__ */ a("ZodULID", (e, t) => {
  Wn.init(e, t), S.init(e, t);
}), Ai = /* @__PURE__ */ a("ZodXID", (e, t) => {
  Gn.init(e, t), S.init(e, t);
}), ji = /* @__PURE__ */ a("ZodKSUID", (e, t) => {
  qn.init(e, t), S.init(e, t);
}), Ci = /* @__PURE__ */ a("ZodIPv4", (e, t) => {
  eo.init(e, t), S.init(e, t);
}), Ri = /* @__PURE__ */ a("ZodIPv6", (e, t) => {
  to.init(e, t), S.init(e, t);
}), Fi = /* @__PURE__ */ a("ZodCIDRv4", (e, t) => {
  no.init(e, t), S.init(e, t);
}), Ui = /* @__PURE__ */ a("ZodCIDRv6", (e, t) => {
  oo.init(e, t), S.init(e, t);
}), xi = /* @__PURE__ */ a("ZodBase64", (e, t) => {
  ro.init(e, t), S.init(e, t);
}), Li = /* @__PURE__ */ a("ZodBase64URL", (e, t) => {
  so.init(e, t), S.init(e, t);
}), Mi = /* @__PURE__ */ a("ZodE164", (e, t) => {
  co.init(e, t), S.init(e, t);
}), Ji = /* @__PURE__ */ a("ZodJWT", (e, t) => {
  ao.init(e, t), S.init(e, t);
}), Se = /* @__PURE__ */ a("ZodNumber", (e, t) => {
  ft.init(e, t), w.init(e, t), e._zod.processJSONSchema = (o, r, i) => Cr(e, o, r), e.gt = (o, r) => e.check(/* @__PURE__ */ Le(o, r)), e.gte = (o, r) => e.check(/* @__PURE__ */ ie(o, r)), e.min = (o, r) => e.check(/* @__PURE__ */ ie(o, r)), e.lt = (o, r) => e.check(/* @__PURE__ */ xe(o, r)), e.lte = (o, r) => e.check(/* @__PURE__ */ re(o, r)), e.max = (o, r) => e.check(/* @__PURE__ */ re(o, r)), e.int = (o) => e.check(Ve(o)), e.safe = (o) => e.check(Ve(o)), e.positive = (o) => e.check(/* @__PURE__ */ Le(0, o)), e.nonnegative = (o) => e.check(/* @__PURE__ */ ie(0, o)), e.negative = (o) => e.check(/* @__PURE__ */ xe(0, o)), e.nonpositive = (o) => e.check(/* @__PURE__ */ re(0, o)), e.multipleOf = (o, r) => e.check(/* @__PURE__ */ Me(o, r)), e.step = (o, r) => e.check(/* @__PURE__ */ Me(o, r)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function A(e) {
  return /* @__PURE__ */ lr(Se, e);
}
const Vi = /* @__PURE__ */ a("ZodNumberFormat", (e, t) => {
  lo.init(e, t), Se.init(e, t);
});
function Ve(e) {
  return /* @__PURE__ */ dr(Vi, e);
}
const Bi = /* @__PURE__ */ a("ZodBoolean", (e, t) => {
  fo.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Rr(e, n, o);
});
function $(e) {
  return /* @__PURE__ */ pr(Bi, e);
}
const Ki = /* @__PURE__ */ a("ZodAny", (e, t) => {
  po.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Ur();
});
function Wi() {
  return /* @__PURE__ */ hr(Ki);
}
const Gi = /* @__PURE__ */ a("ZodUnknown", (e, t) => {
  ho.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => xr();
});
function Be() {
  return /* @__PURE__ */ mr(Gi);
}
const qi = /* @__PURE__ */ a("ZodNever", (e, t) => {
  mo.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Fr(e, n, o);
});
function Yi(e) {
  return /* @__PURE__ */ _r(qi, e);
}
const Xi = /* @__PURE__ */ a("ZodDate", (e, t) => {
  _o.init(e, t), w.init(e, t), e._zod.processJSONSchema = (o, r, i) => Lr(e, o), e.min = (o, r) => e.check(/* @__PURE__ */ ie(o, r)), e.max = (o, r) => e.check(/* @__PURE__ */ re(o, r));
  const n = e._zod.bag;
  e.minDate = n.minimum ? new Date(n.minimum) : null, e.maxDate = n.maximum ? new Date(n.maximum) : null;
});
function Hi(e) {
  return /* @__PURE__ */ gr(Xi, e);
}
const Qi = /* @__PURE__ */ a("ZodArray", (e, t) => {
  go.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Kr(e, n, o, r), e.element = t.element, e.min = (n, o) => e.check(/* @__PURE__ */ ue(n, o)), e.nonempty = (n) => e.check(/* @__PURE__ */ ue(1, n)), e.max = (n, o) => e.check(/* @__PURE__ */ mt(n, o)), e.length = (n, o) => e.check(/* @__PURE__ */ _t(n, o)), e.unwrap = () => e.element;
});
function O(e, t) {
  return /* @__PURE__ */ Tr(Qi, e, t);
}
const es = /* @__PURE__ */ a("ZodObject", (e, t) => {
  yo.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Wr(e, n, o, r), v(e, "shape", () => t.shape), e.keyof = () => is(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Be() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Be() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Yi() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => Ct(e, n), e.safeExtend = (n) => Rt(e, n), e.merge = (n) => Ft(e, n), e.pick = (n) => At(e, n), e.omit = (n) => jt(e, n), e.partial = (...n) => Ut(wt, e, n[0]), e.required = (...n) => xt(kt, e, n[0]);
});
function m(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...h(t)
  };
  return new es(n);
}
const ts = /* @__PURE__ */ a("ZodUnion", (e, t) => {
  zo.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Gr(e, n, o, r), e.options = t.options;
});
function F(e, t) {
  return new ts({
    type: "union",
    options: e,
    ...h(t)
  });
}
const ns = /* @__PURE__ */ a("ZodIntersection", (e, t) => {
  bo.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => qr(e, n, o, r);
});
function os(e, t) {
  return new ns({
    type: "intersection",
    left: e,
    right: t
  });
}
const rs = /* @__PURE__ */ a("ZodRecord", (e, t) => {
  wo.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Yr(e, n, o, r), e.keyType = t.keyType, e.valueType = t.valueType;
});
function le(e, t, n) {
  return new rs({
    type: "record",
    keyType: e,
    valueType: t,
    ...h(n)
  });
}
const fe = /* @__PURE__ */ a("ZodEnum", (e, t) => {
  ko.init(e, t), w.init(e, t), e._zod.processJSONSchema = (o, r, i) => Mr(e, o, r), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (o, r) => {
    const i = {};
    for (const s of o)
      if (n.has(s))
        i[s] = t.entries[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new fe({
      ...t,
      checks: [],
      ...h(r),
      entries: i
    });
  }, e.exclude = (o, r) => {
    const i = { ...t.entries };
    for (const s of o)
      if (n.has(s))
        delete i[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new fe({
      ...t,
      checks: [],
      ...h(r),
      entries: i
    });
  };
});
function is(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, o])) : e;
  return new fe({
    type: "enum",
    entries: n,
    ...h(t)
  });
}
function ss(e, t) {
  return new fe({
    type: "enum",
    entries: e,
    ...h(t)
  });
}
const cs = /* @__PURE__ */ a("ZodLiteral", (e, t) => {
  $o.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Jr(e, n, o), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function I(e, t) {
  return new cs({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...h(t)
  });
}
const us = /* @__PURE__ */ a("ZodTransform", (e, t) => {
  So.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Br(e, n), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      throw new qe(e.constructor.name);
    n.addIssue = (i) => {
      if (typeof i == "string")
        n.issues.push(Q(i, n.value, t));
      else {
        const s = i;
        s.fatal && (s.continue = !1), s.code ?? (s.code = "custom"), s.input ?? (s.input = n.value), s.inst ?? (s.inst = e), n.issues.push(Q(s));
      }
    };
    const r = t.transform(n.value, n);
    return r instanceof Promise ? r.then((i) => (n.value = i, n)) : (n.value = r, n);
  };
});
function as(e) {
  return new us({
    type: "transform",
    transform: e
  });
}
const wt = /* @__PURE__ */ a("ZodOptional", (e, t) => {
  ht.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => zt(e, n, o, r), e.unwrap = () => e._zod.def.innerType;
});
function Ke(e) {
  return new wt({
    type: "optional",
    innerType: e
  });
}
const ls = /* @__PURE__ */ a("ZodExactOptional", (e, t) => {
  Zo.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => zt(e, n, o, r), e.unwrap = () => e._zod.def.innerType;
});
function fs(e) {
  return new ls({
    type: "optional",
    innerType: e
  });
}
const ds = /* @__PURE__ */ a("ZodNullable", (e, t) => {
  Oo.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Xr(e, n, o, r), e.unwrap = () => e._zod.def.innerType;
});
function We(e) {
  return new ds({
    type: "nullable",
    innerType: e
  });
}
const ps = /* @__PURE__ */ a("ZodDefault", (e, t) => {
  Eo.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Qr(e, n, o, r), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function hs(e, t) {
  return new ps({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Qe(t);
    }
  });
}
const ms = /* @__PURE__ */ a("ZodPrefault", (e, t) => {
  To.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => ei(e, n, o, r), e.unwrap = () => e._zod.def.innerType;
});
function _s(e, t) {
  return new ms({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Qe(t);
    }
  });
}
const kt = /* @__PURE__ */ a("ZodNonOptional", (e, t) => {
  Io.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Hr(e, n, o, r), e.unwrap = () => e._zod.def.innerType;
});
function gs(e, t) {
  return new kt({
    type: "nonoptional",
    innerType: e,
    ...h(t)
  });
}
const vs = /* @__PURE__ */ a("ZodCatch", (e, t) => {
  Po.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => ti(e, n, o, r), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function ys(e, t) {
  return new vs({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const zs = /* @__PURE__ */ a("ZodPipe", (e, t) => {
  No.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => ni(e, n, o, r), e.in = t.in, e.out = t.out;
});
function Ge(e, t) {
  return new zs({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const bs = /* @__PURE__ */ a("ZodReadonly", (e, t) => {
  Do.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => oi(e, n, o, r), e.unwrap = () => e._zod.def.innerType;
});
function ws(e) {
  return new bs({
    type: "readonly",
    innerType: e
  });
}
const ks = /* @__PURE__ */ a("ZodLazy", (e, t) => {
  Ao.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => ri(e, n, o, r), e.unwrap = () => e._zod.def.getter();
});
function Ze(e) {
  return new ks({
    type: "lazy",
    getter: e
  });
}
const $s = /* @__PURE__ */ a("ZodCustom", (e, t) => {
  jo.init(e, t), w.init(e, t), e._zod.processJSONSchema = (n, o, r) => Vr(e, n);
});
function Ss(e, t = {}) {
  return /* @__PURE__ */ Ir($s, e, t);
}
function Zs(e) {
  return /* @__PURE__ */ Pr(e);
}
function Os(e) {
  return /* @__PURE__ */ fr(Se, e);
}
const Es = m({
  id: A(),
  name: p(),
  labId: A(),
  status: p(),
  ipAddress: p().nullable(),
  lastLogin: Hi().nullable()
}), Hs = m({
  tinkerboxes: O(Es)
}), Ts = m({
  key: p(),
  name: p(),
  isFolder: $(),
  bucket: p(),
  fullPath: p()
}), Qs = m({
  contents: O(Ts)
}), ec = m({
  buckets: O(
    m({
      id: A().int(),
      bucket: p(),
      region: p(),
      prefix: p().nullish()
    })
  )
}), Is = m({
  name: p(),
  type: I("select"),
  options: O(p()),
  optional: $().optional(),
  allowOther: $().optional(),
  validate: p().optional(),
  question: p().optional()
}), Ps = m({
  name: p(),
  type: F([I("text"), I("textarea")]),
  optional: $().optional(),
  validate: p().optional(),
  question: p().optional()
}), Ns = m({
  name: p(),
  type: I("email"),
  optional: $().optional(),
  validate: p().optional(),
  question: p().optional()
}), Ds = m({
  name: p(),
  type: I("submit"),
  text: p().optional(),
  optional: $().optional(),
  validate: p().optional(),
  question: p().optional()
}), tc = O(
  m({
    name: p(),
    value: p()
  })
), As = F([
  Is,
  Ps,
  Ns,
  Ds
]), nc = O(As), js = m({
  content: p(),
  is_error: $(),
  show: $()
}), Cs = m({
  id: p(),
  results: O(js).nullish(),
  cell_type: p(),
  metadata: m({
    collapsed: $().nullish(),
    trusted: $().nullish()
  }),
  source: F([p(), O(p())]),
  outputs: O(Wi()).nullish(),
  execution_count: A().nullish()
}), Rs = m({
  kernelspec: m({
    display_name: p(),
    language: p(),
    name: p()
  }),
  language_info: m({
    codemirror_mode: m({
      name: p(),
      version: A()
    }),
    file_extension: p(),
    mimetype: p(),
    name: p(),
    nbconvert_exporter: p(),
    pygments_lexer: p(),
    version: p()
  })
}), oc = m({
  cells: O(Cs),
  metadata: Rs,
  nbformat_minor: A(),
  nbformat: A()
});
var $t = /* @__PURE__ */ ((e) => (e.ALL = "all", e.NONE = "none", e.FILE = "file", e.DIR = "dir", e.FILE_LIST = "file_list", e.DIR_LIST = "dir_list", e))($t || {});
const rc = [
  "all",
  "none",
  "file",
  "dir",
  "file_list",
  "dir_list"
  /* DIR_LIST */
];
var Fs = /* @__PURE__ */ ((e) => (e.FILE_SELECTED = "FILE_SELECTED", e.FILES_DROPPED = "FILES_DROPPED", e.FOLDER_SELECTED = "FOLDER_SELECTED", e.BACK_BUTTON_PRESSED = "BACK_BUTTON_PRESSED", e))(Fs || {});
const Us = m({
  _type: I("string"),
  _validation: p().optional(),
  _value: p().optional(),
  _optional: $().optional()
}), xs = m({
  _type: I("boolean"),
  _value: $().optional(),
  _optional: $().optional()
}), Ls = m({
  _type: I("selection"),
  _options: O(p()),
  _optional: $().optional(),
  _value: p().optional()
}), St = m({
  fsId: p(),
  isFolder: $(),
  path: p()
}), Ms = ss($t), J = Ze(
  () => F([
    Bs,
    Js,
    Ls,
    Us,
    Vs,
    xs
  ])
), Js = m({
  _type: I("path"),
  _value: F([O(St), O(p())]).optional(),
  // _value: z.array(s3PathSchema).optional(),
  _regexp: p().optional(),
  _optional: $().optional(),
  _pathType: Ms
}), Vs = Ze(
  () => m({
    _type: I("list"),
    _value: O(J).optional(),
    _optional: $().optional(),
    _schema: J
  })
), Bs = Ze(
  () => m({
    _type: I("object"),
    _optional: $().optional(),
    _fields: le(p(), J),
    _value: le(p(), J).optional(),
    _order: O(p()).optional()
  })
), ic = le(
  Os(),
  J
), sc = le(
  p(),
  J
), Ks = m({
  type: I("pattern"),
  pattern: p()
}), Ws = m({
  type: I("value"),
  value: F([p(), A(), $(), O(St)])
}), Gs = m({
  type: I("code"),
  codeBase64: p()
}), qs = F([
  Ks,
  Ws,
  Gs
]), cc = J.and(
  m({
    _actionData: qs.optional()
  })
), uc = {
  connect: "connect",
  data: "data",
  notebookDataResults: "notebookDataResults",
  notebookDataFinished: "notebookDataFinished",
  connectionCreated: "connectionCreated",
  error: "error",
  authError: "authError",
  disconnect: "disconnect",
  directoryContents: "directoryContents",
  fileDownloadUrl: "fileDownloadUrl",
  directoryChanged: "directoryChanged",
  logout: "logout",
  searchResults: "searchResults",
  tinkerboxConnected: "tinkerboxConnected",
  socketReady: "socketReady"
  // the websocket connects instantly, but there's a tiny delay in adding the user object to the socket so once that's done we emit socket ready
}, ac = {
  data: "data",
  notebookData: "notebookData",
  tinkerBoxConnect: "tinkerBoxConnect",
  resize: "resize",
  directoryContents: "directoryContents",
  downloadFile: "downloadFile",
  setPwdSync: "setPwdSync",
  changeRemoteDirectory: "changeRemoteDirectory",
  search: "search",
  logout: "logout",
  deleteFile: "deleteFile",
  createFolder: "createFolder",
  isSocketReady: "isSocketReady",
  termState: "termState",
  ping: "ping"
}, Zt = m({
  permissions: p(),
  links: p(),
  owner: p(),
  group: p(),
  size: p(),
  month: p(),
  date: p(),
  yearOrTime: p(),
  name: p(),
  fullPath: p()
}), Ys = O(Zt), lc = m({
  url: p()
}), fc = m({
  socketId: p(),
  hasSavedSession: $().nullish()
}), dc = m({
  path: p()
}), pc = m({
  directory: p(),
  contents: Ys
}), hc = m({
  syncPwd: $()
}), mc = m({
  defaultDirectory: p(),
  termState: p().nullish()
}), _c = m({
  path: p()
}), gc = m({
  query: p()
}), vc = m({
  results: O(Zt),
  date: p(),
  query: p()
}), yc = m({
  id: p(),
  command: p()
}), Xs = F([
  I("action"),
  I("code")
]), zc = m({
  id: p(),
  resultType: Xs,
  results: O(
    m({
      content: p(),
      isError: $()
    })
  ),
  exitCode: A()
}), bc = m({
  tinkerBoxId: A(),
  rows: A(),
  cols: A(),
  syncPwd: $().nullish()
}), wc = m({
  path: p()
}), kc = m({
  path: p()
}), $c = m({
  termState: p()
});
export {
  js as CellResultSchema,
  Cs as CellSchema,
  _c as ChangeRemoteDirectoryMessage,
  ac as ClientMessage,
  tc as CompletedFormSchema,
  mc as ConnectionCreatedMessage,
  Qs as ContentsResponseSchema,
  kc as CreateFolderMessageSchema,
  wc as DeleteFileMessageSchema,
  pc as DirectoryChangedMessage,
  Ys as DirectoryContentsMessage,
  dc as DownloadFileMessage,
  Ns as EmailSchema,
  Fs as FileBrowserAnalysisType,
  $t as FileBrowserSelectionType,
  rc as FileBrowserSelectionTypeArray,
  lc as FileDownloadUrlMessage,
  As as FormFieldSchema,
  nc as FormSchemaSchema,
  ec as GetBucketsResponseSchema,
  Hs as GetTinkerBoxesResponseSchema,
  Rs as MetadataSchema,
  oc as NotebookContentSchema,
  yc as NotebookDataMessage,
  Xs as NotebookDataResultTypeSchema,
  zc as NotebookDataResultsMessage,
  Ts as S3ObjectSchema,
  gc as SearchMessage,
  vc as SearchResultsMessageSchema,
  Is as SelectSchema,
  uc as ServerMessage,
  hc as SetPwdSyncMessage,
  fc as SocketReadyMessage,
  Ds as SubmitSchema,
  $c as TermStateMessageSchema,
  Ps as TextSchema,
  bc as TinkerBoxConnectMessageSchema,
  Zt as TinkerBoxFileOrDirectory,
  Es as TinkerBoxSchema,
  qs as actionDataSchema,
  xs as booleanTypeSchema,
  Gs as codeActionSchema,
  St as filePathSchema,
  Vs as listTypeSchema,
  Bs as objectTypeSchema,
  Js as pathTypeSchema,
  Ks as patternActionSchema,
  Ms as s3PathTypeSchema,
  Ls as selectionTypeSchema,
  Us as stringTypeSchema,
  Ws as valueActionSchema,
  J as valueTypeSchema,
  cc as valueTypeSchemaWithActionData,
  ic as valuesByAnalysisInputSchemaIdSchema,
  sc as valuesByAnalysisInputSchemaNameSchema
};
//# sourceMappingURL=index.js.map
